import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  LinearProgress,
  Collapse,
  IconButton,
  TextField,
  Tooltip,
  Stack,
  InputAdornment,
  Card,
  CardContent,
  Divider,
  TablePagination,
} from "@mui/material";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  Edit,
  Search,
  ReceiptLong,
  CalendarMonth,
  Person,
  CurrencyRupee,
} from "@mui/icons-material";
import configServ from "../../services/config";
import PrintIcon from "@mui/icons-material/Print";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import CustomDateRangePicker from "../../Components/DatePicker/CustomDateRangePicker";
import pdfImage from "../../Components/Assets/images/pdf.jfif";
import excelImage from "../../Components/Assets/images/excel.png";
import DownloadChallanPdf from "../../Components/Download/DownloadChallanPdf ";
import { useSelector } from "react-redux";
import DownloadChallanExcel from "../../Components/Download/DownloadChallanExcel";
import ChallanDispatchPopup from "./ChallanDispatchPopup";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

// import withReactContent from "sweetalert2-react-content";
const ChallanTable = ({
  handleEditData,
  isChanged,
  handleCopyChallan,
  data,
}) => {
  const [challans, setChallans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openRow, setOpenRow] = useState(null);
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchChallan, setSearchChallan] = useState("");
  const [page, setPage] = useState(0); // MUI Pagination is 0-based
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [total, setTotal] = useState(0);
  const [dateRange, setDateRange] = useState([null, null]);
  const [refresh, setRefresh] = useState(false);

  const { company_id, companyName, permissions, is_super, is_admin } =
    useSelector((state) => state.GlobalVariables);
  useEffect(() => {
    if (data) {
      handlePrint(data);
      console.log("print", data);
    }
  }, [data]);
  useEffect(() => {
    fetchChallans();
  }, [
    page,
    rowsPerPage,
    searchCustomer,
    searchChallan,
    isChanged,
    dateRange,
    refresh,
  ]);

  useEffect(() => {
    setPage(0); // Reset to first page on filter change
    fetchChallans();
  }, [dateRange, refresh]);

  const fetchChallans = async () => {
    try {
      setLoading(true);
      const res = await configServ.getAllChallans({
        company_id: company_id,
        page: page + 1, // API usually expects 1-based index
        per_page: rowsPerPage,
        customer_name: searchCustomer,
        challan_no: searchChallan,
        start_date: dateRange[0]
          ? dayjs(dateRange[0]).format("YYYY-MM-DD")
          : "",
        end_date: dateRange[1] ? dayjs(dateRange[1]).format("YYYY-MM-DD") : "",
      });
      setChallans(res.data || []);
      setTotal(res.total || 0);
    } catch (error) {
      console.error("Error fetching challans", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const handlePrint = async (data) => {
  //   console.log("print",data)
  //   try {
  //     const response = await configServ.PrintChallan_PDF_api({
  //       id: data.id,
  //       page: 1,
  //     });

  //     if (response.status !== 200) {
  //       alert("PDF generate nahi hua");
  //       return;
  //     }

  //     const base64PDF = response.pdf;
  //     const fileName = response.file_name;

  //     // 🔥 Convert Base64 → Download
  //     const linkSource = `data:application/pdf;base64,${base64PDF}`;
  //     const downloadLink = document.createElement("a");

  //     downloadLink.href = linkSource;
  //     downloadLink.download = fileName;
  //     downloadLink.click();
  //   } catch (error) {
  //     console.error("Print Error:", error);
  //   }
  // };

  // const MySwal = withReactContent(Swal);

  const handlePrint = async (data) => {
    setLoading(true);
    let customerEmail = null;
    let isEmailEnabled = false;

    try {
      // 1. Fetch Email
      const emailRes = await configServ.getCustomerEmailByID({
        customer_id: data.customer_id || data.from_customer_id,
      });
      console.log("emailRes", emailRes);
      if (emailRes.status === 200 && emailRes.data) {
        customerEmail = emailRes.data;
        isEmailEnabled = true;
      }
    } catch (e) {
      console.error("Email fetch error", e);
    }

    setLoading(false);

    // 2. Custom Styled Popup
    Swal.fire({
      title: "",
      showConfirmButton: false,
      showCloseButton: true,
      width: 450,
      html: `
      <div style="display: flex; border-bottom: 2px solid #eee; margin-bottom: 20px;">
        <div id="tab-email" style="flex: 1; padding: 10px; cursor: pointer; font-weight: bold; color: #1976d2; border-bottom: 3px solid #1976d2;">EMAIL</div>
        <div id="tab-print" style="flex: 1; padding: 10px; cursor: pointer; font-weight: bold; color: #666;">PRINT</div>
      </div>

      <div id="content-container" style="min-height: 200px; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 10px;">
        
        <div id="view-email" style="text-align: center; width: 100%;">
          <h3 style="color: #555; font-weight: 400; margin-bottom: 20px;">Save paper, send the challan via email!</h3>
          <button id="realEmailBtn" class="swal2-styled" 
            style="background-color: ${isEmailEnabled ? "#4caf50" : "#e0e0e0"}; color: ${isEmailEnabled ? "#fff" : "#999"}; padding: 10px 25px; display: flex; align-items: center; gap: 8px; margin: 0 auto; cursor: ${isEmailEnabled ? "pointer" : "not-allowed"}" 
            ${!isEmailEnabled ? "disabled" : ""}>
            <span class="material-icons" style="font-size: 18px;">mail</span> SEND EMAIL
          </button>
          ${
            !isEmailEnabled
              ? `
            <p style="color: #d32f2f; margin-top: 20px; font-size: 14px; font-weight: 500;">
              No email address found. Please update customer email to continue.
            </p>
          `
              : `<p style="color: #2e7d32; margin-top: 15px;">Send to: ${customerEmail}</p>`
          }
        </div>

        <div id="view-print" style="display: none; text-align: center; width: 100%;">
          <h3 style="color: #555; font-weight: 400; margin-bottom: 10px;">Select Print Settings</h3>
          <div style="margin-bottom: 20px;">
            <label style="display: block; margin-bottom: 8px; font-size: 14px; color: #666;">Number of Pages</label>
           <div id="print-pages" style="display: flex; justify-content: center; gap: 20px;">
  <label style="font-size: 14px; color: #666;">
    <input type="radio" name="print_page" value="1" checked />
    1 Page
  </label>

  <label style="font-size: 14px; color: #666;">
    <input type="radio" name="print_page" value="2" />
    2 Pages
  </label>

  <label style="font-size: 14px; color: #666;">
    <input type="radio" name="print_page" value="3" />
    3 Pages
  </label>
</div>
          </div>
          <button id="realPrintBtn" class="swal2-confirm swal2-styled" style="background-color: #1976d2; padding: 10px 30px;">
            DOWNLOAD PDF
          </button>
        </div>

      </div>
    `,
      didOpen: () => {
        const tEmail = document.getElementById("tab-email");
        const tPrint = document.getElementById("tab-print");
        const vEmail = document.getElementById("view-email");
        const vPrint = document.getElementById("view-print");

        // Tab Switching Logic
        tEmail.addEventListener("click", () => {
          tEmail.style.color = "#1976d2";
          tEmail.style.borderBottom = "3px solid #1976d2";
          tPrint.style.color = "#666";
          tPrint.style.borderBottom = "none";
          vEmail.style.display = "block";
          vPrint.style.display = "none";
        });

        tPrint.addEventListener("click", () => {
          tPrint.style.color = "#1976d2";
          tPrint.style.borderBottom = "3px solid #1976d2";
          tEmail.style.color = "#666";
          tEmail.style.borderBottom = "none";
          vPrint.style.display = "block";
          vEmail.style.display = "none";
        });

        // Email Action
        // Email Action inside Swal didOpen
        document
          .getElementById("realEmailBtn")
          .addEventListener("click", async () => {
            Swal.showLoading();
            try {
              const res = await configServ.sendEmailApiChallan({
                id: data.id,
                email: customerEmail,
              });

              if (res.status === 200) {
                Swal.fire(
                  "Sent!",
                  "Email has been sent to " + customerEmail,
                  "success",
                );
              } else {
                Swal.fire(
                  "Error",
                  res.message || "Failed to send email",
                  "error",
                );
              }
            } catch (err) {
              Swal.fire("Error", "Server connection failed", "error");
            }
          });

        // Print Action
        document
          .getElementById("realPrintBtn")
          .addEventListener("click", async () => {
            const selectedRadio = document.querySelector(
              'input[name="print_page"]:checked',
            );
            const pages = selectedRadio ? selectedRadio.value : 1;

            Swal.close();
            handleActualDownload(data.id, pages);
          });
      },
    });
  };

  // Separate function for download to keep code clean
  const handleActualDownload = async (id, pages) => {
    setLoading(true);
    try {
      const response = await configServ.PrintChallan_PDF_api({
        id,
        page: pages,
      });
      if (response.status === 200) {
        const linkSource = `data:application/pdf;base64,${response.pdf}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = response.file_name || "challan.pdf";
        downloadLink.click();
      } else {
        Swal.fire("Error", "Could not generate PDF", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Server Error", "error");
    } finally {
      setLoading(false);
    }
  };

  // --- Sub-Component for Mobile Cards ---
  const MobileCard = ({ row }) => (
    <Card
      sx={{
        mb: 2,
        borderRadius: 2,
        boxShadow: 2,
        borderLeft: "5px solid #1976d2",
      }}
    >
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography variant="subtitle1" fontWeight="bold" color="primary">
            #{row.challan_no}
          </Typography>
          {Boolean(is_super || is_admin || permissions?.includes(63)) && (
            <IconButton color="primary" onClick={() => handleEditData(row)}>
              <Edit />
            </IconButton>
          )}
          <IconButton color="primary" onClick={() => handleCopyChallan(row)}>
            <ReceiptLong />
          </IconButton>
          <IconButton color="primary" onClick={() => handlePrint(row)}>
            <PrintIcon />
          </IconButton>
          <IconButton
            color="primary"
            onClick={() => handleDispatch(row)}
            disabled={row.is_dispatch}
          >
            <LocalShippingIcon />
          </IconButton>
        </Stack>

        <Stack spacing={1}>
          <Box display="flex" alignItems="center" gap={1}>
            <Person fontSize="small" color="action" />
            <Typography variant="body2">
              {row.customer?.contact_name}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <CalendarMonth fontSize="small" color="action" />
            <Typography variant="body2">
              {new Date(row.challan_date).toLocaleDateString()}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <CurrencyRupee fontSize="small" color="action" />
            <Typography variant="body1" fontWeight="600">
              {parseFloat(row.total_amount).toFixed(2)}
            </Typography>
          </Box>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Box>
          <Typography
            variant="caption"
            sx={{
              cursor: "pointer",
              color: "#1976d2",
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => setOpenRow(openRow === row.id ? null : row.id)}
          >
            {openRow === row.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            {openRow === row.id ? "Hide Items" : "View Items"}
          </Typography>
          <Collapse in={openRow === row.id}>
            <Box mt={1} sx={{ bgcolor: "#f5f5f5", p: 1, borderRadius: 1 }}>
              {row.items?.map((item) => (
                <Typography key={item.id} variant="caption" display="block">
                  • {item.itemname} - ({item.qty}) x ({item.rate}) = ₹
                  {item.amount}
                </Typography>
              ))}
            </Box>
          </Collapse>
        </Box>
      </CardContent>
    </Card>
  );
  const [companyLogo, setCompanyLogo] = useState("");
  const [openBackdrop, setOpenBackdrop] = useState(false);

  const assignCompanyLogo = async () => {
    try {
      const result = await configServ.company_logo({ company_id: company_id });
      if (result && result.image) {
        // Assuming the result.image is already a base64 string
        setCompanyLogo(`data:image/png;base64,${result.image}`);
      } else {
        setCompanyLogo(null); // Set as null if no logo
      }
    } catch (e) {
      console.log(e);
      setCompanyLogo(null); // Handle error by clearing logo
    }
  };

  useEffect(() => {
    assignCompanyLogo();
  }, []);

  const handleDownloadPdf = () => {
    DownloadChallanPdf(challans, companyName, companyLogo, setOpenBackdrop);
  };

  const handleDownloadExcel = () => {
    DownloadChallanExcel(challans, companyName, setOpenBackdrop);
  };
  const [openDispatch, setOpenDispatch] = useState(false);
  const [dispatchDetail, setDispatchDetail] = useState(null);
  const closeDispatchPopup = () => {
    setOpenDispatch(false);
    setRefresh(!refresh);
  };
  const openDispatchPopup = () => {
    setOpenDispatch(true);
  };

  const handleDispatch = (params) => {
    try {
      const data = params;
      setDispatchDetail(data);
      openDispatchPopup();
      // handleClose();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <ChallanDispatchPopup
        openDispatch={openDispatch}
        closeDispatchPopup={closeDispatchPopup}
        dispatchDetail={dispatchDetail}
        refresh={refresh}
      />
      <Box sx={{ width: "100%", p: { xs: 1, md: 3 } }}>
        {/* Header & Filters */}
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", md: "center" }}
          spacing={2}
          mb={3}
        >
          <Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: "#1976d2",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <ReceiptLong /> Challan List
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Showing {total} records
            </Typography>
          </Box>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            sx={{ width: { xs: "100%", md: "auto" } }}
          >
            <TextField
              label="Search Customer"
              size="small"
              value={searchCustomer}
              onChange={(e) => {
                setPage(0);
                setSearchCustomer(e.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              label="Challan No"
              size="small"
              value={searchChallan}
              onChange={(e) => {
                setPage(0);
                setSearchChallan(e.target.value);
              }}
            />
            {/* Date Range Picker */}

            <CustomDateRangePicker value={dateRange} onChange={setDateRange} />
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Tooltip title="Download PDF">
                <IconButton onClick={handleDownloadPdf}>
                  <img
                    src={pdfImage} // 👈 tumhara pdf image path
                    alt="pdf"
                    style={{ width: 28, height: 28 }}
                  />
                </IconButton>
              </Tooltip>

              <Tooltip title="Download Excel">
                <IconButton onClick={handleDownloadExcel}>
                  <img
                    src={excelImage} // 👈 tumhara excel image path
                    alt="excel"
                    style={{ width: 28, height: 28 }}
                  />
                </IconButton>
              </Tooltip>
            </Box>
          </Stack>
        </Stack>

        {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}

        {/* DESKTOP TABLE VIEW */}
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <TableContainer
            component={Paper}
            sx={{ borderRadius: 2, boxShadow: 3 }}
          >
            <Table>
              <TableHead sx={{ bgcolor: "#1976d2" }}>
                <TableRow>
                  <TableCell width="50" />
                  <TableCell sx={{ color: "#fff", fontWeight: 600 }}>
                    Challan No
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: 600 }}>
                    Site Name
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: 600 }}>
                    Date
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: 600 }}>
                    Amount
                  </TableCell>
                  <TableCell
                    sx={{ color: "#fff", fontWeight: 600 }}
                    align="center"
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {challans.map((row) => (
                  <React.Fragment key={row.id}>
                    <TableRow hover>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() =>
                            setOpenRow(openRow === row.id ? null : row.id)
                          }
                        >
                          {openRow === row.id ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )}
                        </IconButton>
                      </TableCell>
                      <TableCell fontWeight="500">{row.challan_no}</TableCell>
                      <TableCell>{row.customer?.contact_name}</TableCell>
                      <TableCell>
                        {new Date(row.challan_date).toLocaleDateString()}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        ₹{row.total_amount}
                      </TableCell>
                      <TableCell align="center">
                        {Boolean(
                          is_super || is_admin || permissions?.includes(63),
                        ) && (
                          <IconButton
                            color="primary"
                            onClick={() => handleEditData(row)}
                          >
                            <Edit />
                          </IconButton>
                        )}

                        <IconButton
                          color="primary"
                          onClick={() => handleCopyChallan(row)}
                        >
                          <ReceiptLong />
                        </IconButton>
                        <IconButton
                          color="primary"
                          onClick={() => handleDispatch(row)}
                          disabled={row.is_dispatch}
                        >
                          <LocalShippingIcon />
                        </IconButton>
                        <IconButton
                          color="primary"
                          onClick={() => handlePrint(row)}
                        >
                          <PrintIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ py: 0 }} colSpan={6}>
                        <Collapse in={openRow === row.id} unmountOnExit>
                          <Box
                            m={2}
                            p={2}
                            sx={{ bgcolor: "#fafafa", borderRadius: 1 }}
                          >
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Item</TableCell>
                                  <TableCell align="right">Qty</TableCell>
                                  <TableCell align="right">Rate</TableCell>
                                  <TableCell align="right">Total</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {row.items?.map((item) => (
                                  <TableRow key={item.id}>
                                    <TableCell>{item.itemname}</TableCell>
                                    <TableCell align="right">
                                      {item.qty}
                                    </TableCell>
                                    <TableCell align="right">
                                      ₹{item.rate}
                                    </TableCell>
                                    <TableCell align="right">
                                      ₹{item.amount}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* MOBILE CARD VIEW */}
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          {challans.map((row) => (
            <MobileCard key={row.id} row={row} />
          ))}
        </Box>

        {/* COMMON PAGINATION */}
        <TablePagination
          component="div"
          count={total}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
          sx={{ mt: 2 }}
        />
      </Box>
    </>
  );
};

export default ChallanTable;
